export default function createAsyncActionTypes(baseType: string) {
  return {
    REQUEST: baseType,
    SUCCESS: `${baseType}_SUCCESS`,
    FAILURE: `${baseType}_FAILURE`,
    DONE: `${baseType}_DONE`,
  };
}
